// extracted by mini-css-extract-plugin
export var activityContainer = "_nm-0";
export var typingIndicatorContainer = "_nm-1";
export var typingIndicatorDot = "_nm-2";
export var wave = "_nm-3";